import React, { useEffect, useState } from "react";
import CustomTable from "../../../../components/Tables/CustomTable";
import { MoreVertical } from "lucide-react";
import DropdownMenu from "../../../ui/DropdownMenu";
import { useNavigate } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "../../../../redux/app/hooks";

import { RootState } from "../../../../redux/app/store";
import moment from "moment";
import { cleanObject, formatNumberWithCommas } from "../../../../helpers";
import { getStatusStyles } from "../util";
import { fetchAllExecutedOrdersAsync } from "../../../../redux/features/orderSlice";
import ClickableUserName from "../../../../components/shared/ClickableUserName";

const ExecutedOrdersTable = () => {
  const { loading, executedOrders } = useAppSelector(
    (state: RootState) => state.orders,
  );
  const [executedOrderPageLimit, setExecutedOrderPageLimit] =
    useState<number>(10);
  const [executedOrderPage, setExecutedOrderPage] = useState<number>(0);

  const navigate = useNavigate();
  const dispatch = useAppDispatch();

  const executedOrderdORderColumns = [
    { label: "S/N", field: "id" },
    { label: "Contract", field: "contract_code" },
    { label: "Order Weight(Kg)", field: "executedOrder_weight" },
    { label: "Name of Vendor", field: "vendor_name" },
    { label: "Name of Buyer", field: "buyer_name" },
    // { label: "Pickup Location", field: "pickup_location" },
    { label: "Order Amount", field: "order_amount" },
    { label: "Created Date", field: "created_date" },
    { label: "Dispatch Status", field: "dispatch_status" },
    { label: "Order Status", field: "status" },
    { label: "executedOrder Status", field: "executedOrder_status" },
    {
      label: "Buyer's reason for executedOrder",
      field: "executedOrder_reason",
    },
    { label: "Action", field: "executedOrder_action" },
  ];

  const executedOrderDropdownOptions = [
    {
      label: "View order details",
      onClick: (item: any) => {
        navigate(`/executedOrder-order-details/${item?.id}`);
      },
      returnAll: true,
    },
    // {
    //   label: <div className="text-accent">Approve executedOrder order</div>,
    //   onClick: () => setOpenApproveexecutedOrderModal(true),
    // },
  ];

  const executedOrderOrderData = executedOrders?.data?.map(
    (executedOrder: any, index: number) => {
      const isPaid =
        executedOrder?.status === "PAID" ||
        executedOrder?.status === "COMPLETED";
      return {
        _executedOrderId: executedOrder?.id,
        id: index + 1,
        contract_id: executedOrder?.contract?.title,
        executedOrder_weight:
          executedOrder?.order?.contract?.actualWeight ?? "N/A",
        vendor_name: (
          <ClickableUserName
            user={executedOrder?.order?.contract?.vendorId}
            userType="VENDOR"
          />
        ),
        buyer_name: (
          <ClickableUserName
            user={executedOrder?.order?.contract?.buyerId}
            userType="BUYER"
          />
        ),
        pickup_location: executedOrder?.pickupLocation?.address,
        contract_code: executedOrder?.order?.contract?.contractCode,
        created_date: moment(executedOrder?.createdAt).format("Do MMM YYYY"),
        order_amount: executedOrder?.order?.orderAmount
          ? `₦ ${formatNumberWithCommas(executedOrder?.order?.orderAmount)}`
          : "N/A",
        executedOrder_reason:
          executedOrder?.question?.executedOrderReason?.name,
        dispatch_status: (
          <span
            className={`text-xs px-3 py-1 rounded-md font-semibold ${getStatusStyles(
              executedOrder?.order?.dispatchStatus,
            )}`}
          >
            {executedOrder?.order?.dispatchStatus}
          </span>
        ),
        status: (
          <span
            className={`text-xs px-3 py-1 rounded-md font-semibold ${
              isPaid
                ? "bg-green-50 text-green-500 border border-green-500"
                : executedOrder?.order?.status === "PENDING"
                  ? "bg-yellow-50 text-yellow-500 border border-yellow-500"
                  : "bg-red-50 text-red-500 border border-red-500"
            }`}
          >
            {executedOrder?.order?.status}
          </span>
        ),
        executedOrder_status: (
          <span
            className={`text-xs px-3 py-1 rounded-md font-semibold ${
              executedOrder?.executedOrderStatus === "RESOLVED"
                ? "bg-green-50 text-green-500 border border-green-500"
                : executedOrder?.executedOrderStatus === "UNDER_REVIEW"
                  ? "bg-indigo-50 text-indigo-500 border border-indigo-500"
                  : "bg-red-50 text-red-500 border border-red-500"
            }`}
          >
            {executedOrder?.executedOrderStatus}
          </span>
        ),
        executedOrder_action: (
          <DropdownMenu
            options={executedOrderDropdownOptions}
            icon={<MoreVertical style={{ cursor: "pointer" }} />}
            item={executedOrder}
          />
        ),
      };
    },
  );

  useEffect(() => {
    const params = cleanObject({
      limit: executedOrderPageLimit,
      page: executedOrderPage + 1,
    });
    dispatch(fetchAllExecutedOrdersAsync(params));
  }, [dispatch, executedOrderPage, executedOrderPageLimit]);

  return (
    <CustomTable
      data={{
        columns: executedOrderdORderColumns,
        rows: executedOrderOrderData,
      }}
      onRowClick={(row) =>
        navigate(`/executedOrder-order-details/${row._executedOrderId}`)
      }
      noRecordText="No Executed Order Available"
      loading={loading}
      showFooter={true}
      totalPages={executedOrders?.meta?.totalPages}
      itemsPerPage={executedOrders?.meta?.itemsPerPage}
      currentPage={executedOrders?.meta?.currentPage}
      onPageChange={(value: number) => setExecutedOrderPage(value)}
      onLimitChange={(value: number) => setExecutedOrderPageLimit(value)}
    />
  );
};

export default ExecutedOrdersTable;
